import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

interface SelectNpgbProps {
	onChange: (e: string) => void;
	value: string;
}

export function SelectNpgb({
	onChange,
	value
}: SelectNpgbProps) {

	return(
		<FormControl fullWidth>
			<InputLabel id='npgb_label'>Selecione o NPGB</InputLabel>
			<Select
				labelId='npgb_label'
				id='select_npgb'
				value={value}
				onChange={(e) => onChange(e.target.value)}
			>
				<MenuItem value='Normal'>Normal</MenuItem>
				<MenuItem value='Atenção'>Atenção</MenuItem>
				<MenuItem value='Alerta'>Alerta</MenuItem>
				<MenuItem value='Emergência'>Emergência</MenuItem>
			</Select>
		</FormControl>
	);
}